import dayjs from 'dayjs';
import React from 'react';

import { Button, Modal } from '@/components';
import { SelectInput } from '@/components/select-input/SelectInput';
import { TimeInput } from '@/components/text-input';
import { useTranslation } from 'react-i18next';
import { PlatformIcon } from '@/utils/platformIcon';

import styles from './Modals.module.css';

interface ChooseDateModalProps {
  onSubmit: () => void;
  onChange: (id: string, field: 'publish_date' | 'publish_time', value: TypeAny) => void;
  data: TypeAny;
  selectedData: TypeAny;
  disabled: boolean;
}

function ChooseDateModal({
  onSubmit,
  data,
  onChange,
  selectedData,
  disabled
}: ChooseDateModalProps) {
  const { t } = useTranslation();

  return (
    <Modal closeButton={false} modalStyles={{ maxWidth: '480px' }}>
      <div className={styles.welcomeModal}>
        <h2 className={`${styles.welcomeModalTitle} ${styles.BottomMarginSm}`}>
          {t('inviteView.chooseDateModal.title')}
        </h2>
        <div className={styles.welcomeModalDescription}>
          {t('inviteView.chooseDateModal.description')}
        </div>

        <div className={styles.welcomeModalBody}>
          {data.beats.map((beat: Api.Beat) => {
            const products = Object.entries(beat.products || {}).map(
              ([key, value]) => `${key}: ${value}`
            );

            const isIGCP = ['IGCP', 'ORGPOST'].includes(beat.beat_type || '');
            if (beat.dates_publish?.length && isIGCP) {
              return (
                <div key={`beat-date-publish-${beat.beat_name}`} className={styles.inviteViewBeat}>
                  <div className={styles.inviteViewBeatHeader}>
                    <div className={styles.inviteViewBeatHeaderTitle}>
                      {PlatformIcon(beat.platform)}
                      <span>{beat.beat_name}</span>
                    </div>
                    {products.map((p) => (
                      <div key={p.replace(/\s+/g, '')} className={styles.inviteViewBeatItem}>
                        {p.replace(/_/g, ' ')}
                      </div>
                    ))}
                  </div>
                  <div className={styles.inviteViewBeatBody}>
                    <div className={styles.inviteViewBeatBodyDate}>
                      <SelectInput
                        value={
                          selectedData.find((b: Api.Beat) => b.beat_id === beat.beat_id)
                            ?.publish_date || null
                        }
                        onChange={(val, objVal) => onChange(beat.beat_id, 'publish_date', objVal)}
                        options={beat.dates_publish.map((date: string) => ({
                          value: dayjs(date).format('YYYY-MM-DD'),
                          label: dayjs(date).format('YYYY-MM-DD')
                        }))}
                      />
                    </div>
                    <div className={styles.inviteViewBeatBodyTime}>
                      <TimeInput
                        value={
                          selectedData.find((b: Api.Beat) => b.beat_id === beat.beat_id)
                            ?.publish_time || '00:00'
                        }
                        onChange={(val) => onChange(beat.beat_id, 'publish_time', val)}
                      />
                    </div>
                  </div>
                </div>
              );
            }
            return '';
          })}
        </div>
        <div className={styles.welcomeModalButton}>
          <Button theme="cta" onClick={onSubmit} disabled={disabled}>
            {t('inviteView.accept')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ChooseDateModal;
